/**
 * @file: 围栏渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as FrontCubeData from '../../../frontCubeData/index';

export function renderGrating(cube: CubeNode): void {
    let height: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'gratingHeight');
    let width: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleWidth');
    let bottom: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleHeight') || 20;

    if (height <= 0) {
        return;
    }
    let jView: JQuery<HTMLElement> = cube.jView;
    let col: number = Math.round(width / 100);
    let row: number = Math.round(height / 10);
    let count: number = col * row;
    let html: string = '';

    for (let i: number = 0; i < count; i++) {
        let lastClass: string = '';

        if ((i + 1) % 5 === 0) {
            lastClass = 'last-item';
        }

        html += `<div class="grating-item ${lastClass}" style="width:${100 / col}%"></div>`;
    }

    let $gratingBox: JQuery<HTMLElement> = jView.find('.gratingBox');

    $gratingBox.css({
        width: width,
        height: height,
        bottom: bottom
    });
    Toolkit.html($gratingBox, html);
}
